export default "__VITE_ASSET__67f26584__"